module.exports = __webpack_public_path__ + "static/media/eve-wad.c068e7be.svg";